module.exports = __webpack_public_path__ + "img/15_Low-body.d693847d.png";